// HybridViewport.tsx
import React, { useEffect, useState } from "react";

type HybridViewportProps = {
  children: React.ReactNode;
  baseWidth?: number;
  baseHeight?: number;
  useHeight?: boolean;
};

const DEFAULT_BASE_W = 1920;

const HybridViewport: React.FC<HybridViewportProps> = ({
  children,
  baseWidth = DEFAULT_BASE_W,
  baseHeight,
  useHeight = false,
}) => {
  const [scale, setScale] = useState<number>(1);

  useEffect(() => {
    const recompute = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      let s = w / baseWidth;
      if (useHeight && typeof baseHeight === "number" && baseHeight > 0) {
        s = Math.min(s, h / baseHeight);
      }
      setScale(Math.min(1, s));
    };

    recompute();
    window.addEventListener("resize", recompute);
    return () => window.removeEventListener("resize", recompute);
  }, [baseWidth, baseHeight, useHeight]);

  const canvasStyle: React.CSSProperties = {
    width: baseWidth, // px
    // height: baseHeight,
    transform: `scale(${scale})`,
    transformOrigin: "top left",
  };

  return (
    <div className="hybrid-viewport-wrap">
      <div className="hybrid-canvas" style={canvasStyle}>
        {children}
      </div>
    </div>
  );
};

export default HybridViewport;
